// extracted by mini-css-extract-plugin
export default {"root":"ColumnModal_root__4OYTA"};